<template>
  <div class="box investment" v-if="individualInvestment">
    <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
    <input type="file" id='aboutPreview' @change='loadAboutPreview' hidden ref="loadAboutPreviewButton"/>
    <input type="file" id='pathPreview' @change='loadPathPreview' hidden ref="loadPathPreviewButton"/>

    <div class="page-header-wrapper" v-bind:style="headerStyle">
      <div class="page-header translucent-wrapper">
        <div class="centered">
          <b-switch v-model='investmentObject.is_hidden'>Скрыть страницу</b-switch>
        </div>

        <div class="centered">
          <span class="button-wrapper" @click="handleLoadInvestmentPhoto">
            <a class="button is-info">+</a>Загрузить фото
          </span>
        </div>

        <b-field>
            <b-input placeholder="Заголовок" v-model="investmentObject.title"></b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Текст" type="textarea" v-model="investmentObject.description"></b-input>
        </b-field>
      </div>
    </div>

    <h2 class="has-text-centered">Описание</h2>
    <div class="investment-description page-header-wrapper" v-bind:style="descriptionStyle">
      <div class="description-wrapper translucent-wrapper">
        <div class="centered">
          <span class="button-wrapper" @click="handleLoadInvestmentAboutPreview">
            <a class="button is-info">+</a>Загрузить превью для видео
          </span>
        </div>

        <b-field>
          <b-input placeholder="Текст" v-model="investmentObject.aboutTitle" class="p-option"></b-input>
        </b-field>

        <b-field>
          <Editor v-model="aboutDescription" :editorToolbar="customToolbar"
            v-bind:id="'aboutDescriptionEditor'" class="p-option color-black"
          />
        </b-field>

        <b-field>
          <b-input placeholder="Ссылка на видео" v-model="investmentObject.aboutVideo" class="p-option"></b-input>
        </b-field>
      </div>
    </div>

    <div>
      <div>
        <div class="caption">
          <h2>Преимущества услуги</h2>
          <span>Максимум 4 блока с преимуществами</span>
        </div>

        <div class="gray-wrapper">
          <b-field>
            <b-input placeholder="Заголовок" v-model="investmentObject.advantagesTitle" class="p-option"></b-input>
          </b-field>
        </div>

        <div class="advantages">
          <draggable v-model="advantagesData">
            <Advantage v-for="advantage in investmentObject.advantages"
              :key="advantage.id" :advantage="advantage"
            />
          </draggable>

          <div class="centered"
            v-if="investmentObject.advantages && investmentObject.advantages.length !== 4"
          >
            <span class="button-wrapper" @click="handleAddAdvantage">
              <a class="button is-info">+</a>Добавить преимущество
            </span>
          </div>
        </div>
      </div>

      <h2 class="has-text-centered">Выбор пути</h2>
      <div class="investment-description page-header-wrapper" v-bind:style="pathchooseStyle">
        <div class="description-wrapper translucent-wrapper">
          <div class="centered">
            <span class="button-wrapper" @click="handleLoadInvestmentPathPreview">
              <a class="button is-info">+</a>Загрузить превью для видео о пути
            </span>
          </div>

          <b-field>
            <b-input placeholder="Текст" v-model="investmentObject.pathTitle" class="p-option"></b-input>
          </b-field>

          <b-field>
            <b-input placeholder="Ссылка на видео" v-model="investmentObject.pathVideo" class="p-option"></b-input>
          </b-field>
        </div>
      </div>

      <div>
        <div class="caption">
          <h2>Пути</h2>
        </div>

        <div class="gray-wrapper">
          <b-field>
            <b-input placeholder="Заголовок" v-model="investmentObject.investmentPathTitle" class="p-option"></b-input>
          </b-field>

          <b-field>
            <b-input placeholder="Описане" type="textarea" v-model="investmentObject.investmentPathDescription" class="p-option"></b-input>
          </b-field>
        </div>

        <div class="advantages">
          <draggable v-model="pathesData">
            <InvestmentPath v-for="path in pathesData"
              :key="path.id" :investmentPath="path"
            />
          </draggable>

          <div class="centered"
            v-if="investmentObject.pathes && investmentObject.pathes.length !== 3"
          >
            <span class="button-wrapper" @click="handleAddPath">
              <a class="button is-info">+</a>Добавить путь
            </span>
          </div>
        </div>
      </div>

      <div>
        <div class="caption">
          <h2>Тарифы</h2>
        </div>

        <div class="description-wrapper">
          <b-field>
            <b-input placeholder="Заголовок" v-model="investmentObject.ratesBlockTitle" class="p-option"></b-input>
          </b-field>
        </div>

        <div class="rates-wrapper">
          <draggable v-model="ratesData" class="is-clearfix">
            <Rate v-for="rate in ratesData" :key="rate.id" :rate="rate"/>
          </draggable>

          <div class="centered">
            <span class="button-wrapper" @click="handleAddRate">
              <a class="button is-info">+</a>Добавить тариф
            </span>
          </div>

          <div class="caption">
            <h2>Сравнение тарифов</h2>
          </div>

          <div class='investment-description'>
            <div class="description-wrapper">
              <b-field>
                <b-input placeholder="Заголовок ссылки на документ"
                  v-model="investmentObject.ratesComparisonTitle" class="p-option"
                ></b-input>
              </b-field>
            </div>

            <div class="centered">
              <span class="button-wrapper" v-if="!investmentObject.ratesComparisonFile"
                @click="handleloadDocument"
              >
                <a class="button is-info">+</a>Загрузить документ сравнения тарифов
              </span>

              <span v-else class="rates-file">
                <a target="_blank" :href="'/' + investmentObject.ratesComparisonFile">
                  Просмотреть документ сравнения тарифов
                </a>

                <img src="/static/img/icons/delete.svg"
                  class="delete-icon" @click="deleteRatesComparisonFile"
                />
              </span>

              <input type="file" @change='loadDocument' hidden ref="loadDocumentButton"/>
            </div>

            <div class="promo-wrapper is-flex">
              <el-select v-model="selectedRatesDocument" placeholder="Выбрать документ тарифов"
                @change="changeRatesDocument" class="p-option" clearable
              >
                <el-option
                  v-for="document in newDocumentsData"
                  :key="[document.path, document.resource_id].join('###')"
                  :label="`${document.display_name}`"
                  :value="[document.path, document.resource_id].join('###')">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="caption">
        <h2>Акция, соответствующая услуге</h2>
        <span>Чтобы добавить акцию перейдите в меню "Акции"</span>
      </div>
      <div class="promo-wrapper is-flex">
        <el-select
          v-model="selectedPromo"
          placeholder="Выбрать акцию"
          @change="changePromo"
          class="p-option"
          clearable
        >
          <el-option
            v-for="promo in servicePromos"
            :key="promo.id"
            :label="promo.title"
            :value="promo.id">
          </el-option>
        </el-select>
      </div>

      <div class="save-content-button centered">
        <button class="button save-content" @click="handleSaveInvestment()" :disabled="disabled">
          {{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import deepcopy from 'deepcopy'
  import draggable from 'vuedraggable'
  import uuidv4 from 'uuid/v4'

  import { VueEditor as Editor } from 'vue2-editor'

  import Advantage from './InvestmentAdvantage'
  import InvestmentPath from './InvestmentPath'
  import Rate from './InvestmentRate'

  export default {
    name: 'IndividualInvestment',

    data () {
      return {
        base64photo: '',
        base64pathPreview: '',
        base64aboutPreview: '',
        disabled: false,
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          ['link']
        ],
        aboutDescription: '',
        selectedPromo: null,
        selectedRatesDocument: null
      }
    },

    computed: {
      ...mapState(['individualInvestment', 'servicePromos', 'documentTypes', 'newDocumentTypes']),
      investmentObject () {
        this.aboutDescription = this.individualInvestment.aboutDescription
        const result = deepcopy(this.individualInvestment)
        if (!result.pathes) {
          result.pathes = []
        }
        return result
      },
      advantagesData: {
        get () {
          return deepcopy(this.individualInvestment.advantages)
        },
        set (val) {
          this.updateOrder(val, 'advantages')
        }
      },
      documentsData: {
        get () {
          const result = []
          deepcopy(this.documentTypes).forEach(x => result.push(...x.documents))
          return result
        }
      },
      newDocumentsData: {
        get () {
          const result = []
          deepcopy(this.newDocumentTypes).forEach(x => result.push(x))
          return result
        }
      },
      pathesData: {
        get () {
          return deepcopy(this.investmentObject.pathes)
        },
        set (val) {
          this.updateOrder(val, 'pathes')
        }
      },
      headerStyle () {
        if (this.investmentObject.photo || this.base64photo) {
          if (!this.base64photo.length) {
            return { background: `url(/upload/photos/${this.individualInvestment.photo})` }
          } else {
            return {background: `url(${this.base64photo})`}
          }
        } else {
          return {background: ''}
        }
      },

      descriptionStyle () {
        if (this.investmentObject.aboutPreview || this.base64aboutPreview) {
          if (!this.base64aboutPreview.length) {
            return { background: `url(/upload/photos/${this.individualInvestment.aboutPreview})` }
          } else {
            return {background: `url(${this.base64aboutPreview})`}
          }
        } else {
          return {background: ''}
        }
      },

      pathchooseStyle () {
        if (this.investmentObject.pathPreview || this.base64pathPreview) {
          if (!this.base64pathPreview.length) {
            return { background: `url(/upload/photos/${this.individualInvestment.pathPreview})` }
          } else {
            return {background: `url(${this.base64pathPreview})`}
          }
        } else {
          return {background: ''}
        }
      },

      ratesData: {
        get () {
          return deepcopy(this.individualInvestment.rates).sort((a, b) => a.order > b.order)
        },
        set (val) {
          const valCopy = deepcopy(val)
          for (let i = 0; i < valCopy.length; i++) {
            valCopy[i].order = i
          }
          this.updateInvestmentRatesOrder(valCopy)
        }
      }
    },

    methods: {
      ...mapActions(['getIndividualInvestment', 'addInvestmentAdvantage', 'addInvestmentPath',
        'addInvestmentRate', 'changeInvestmentRatesComparisonFile', 'saveIndividualInvestment',
        'updateInvestmentRatesOrder', 'getPromosForServices', 'getDocumentsTypes', 'getNewDocumentsTypes']),

      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (e) => {
          this.base64photo = e.target.result
          this.$forceUpdate()
        }
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        this.investmentObject.newPhoto = formData
      },

      changePromo (value) {
        this.investmentObject.promo_id = value && value !== '' ? value : null
      },

      loadPathPreview (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (e) => { this.base64pathPreview = e.target.result }
        const formData = new FormData()
        formData.set('avatar', e.target.files[0])
        this.investmentObject.newPathPreview = formData
      },

      changeRatesDocument (value) {
        this.investmentObject.ratesDocument_id = value
        if (value) {
          this.investmentObject.ratesDocument = this.newDocumentsData.find(d => this.investmentObject.ratesDocument_id.indexOf(d.resource_id) !== -1)
        }
      },

      loadAboutPreview (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (e) => { this.base64aboutPreview = e.target.result }
        const formData = new FormData()
        formData.set('avatar', e.target.files[0])
        this.investmentObject.newAboutPreview = formData
      },

      handleLoadInvestmentPhoto () {
        this.$refs.loadPhotoButton.click()
      },

      handleLoadInvestmentAboutPreview () {
        this.$refs.loadAboutPreviewButton.click()
      },

      handleLoadInvestmentPathPreview () {
        this.$refs.loadPathPreviewButton.click()
      },

      updateOrder (val, field) {
        this.individualInvestment[field] = val
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.individualInvestment[field] = val
      },

      handleAddAdvantage () {
        if (this.investmentObject.advantages.length < 4) {
          this.addInvestmentAdvantage({
            order: this.investmentObject.advantages.length,
            title: '',
            description: '',
            learnMoreButton: {
              title: 'Подробнее',
              url: ''
            },
            investment_id: this.investmentObject.id,
            id: uuidv4()
          })
          this.$forceUpdate()
        }
      },

      handleAddPath () {
        this.addInvestmentPath({
          id: (this.investmentObject.pathes.length + 1).toString(),
          title: '',
          description: '',
          link: '',
          button_title: '',
          button_link: '',
          image: '',
          investment_id: this.investmentObject.id,
          order: this.investmentObject.pathes.length
        })
      },

      handleAddRate () {
        this.addInvestmentRate({
          id: uuidv4(),
          title: '',
          description: '',
          text: '',
          investment_id: this.investmentObject.id,
          order: this.investmentObject.rates.length
        })
      },

      handleloadDocument () {
        this.$refs.loadDocumentButton.click()
      },

      deleteRatesComparisonFile () {
        this.investmentObject.newRatesComparisonFile = null
        this.changeInvestmentRatesComparisonFile('')
      },

      loadDocument (e) {
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('document', file)
        this.investmentObject.newRatesComparisonFile = formData
        this.changeInvestmentRatesComparisonFile(file.name)
        this.individualInvestment.newRatesComparisonFile = formData
      },

      handleSaveInvestment () {
        this.disabled = true
        this.saveIndividualInvestment(this.investmentObject)
          .then(() => {
            this.disabled = false
            this.$toast.open({ message: 'Сохранено' })
          })
      }
    },

    created () {
      this.getIndividualInvestment()
      this.getPromosForServices()
      this.getNewDocumentsTypes()
    },

    watch: {
      aboutDescription () {
        this.investmentObject.aboutDescription = this.aboutDescription
      },
      individualInvestment (val) {
        this.selectedPromo = val.promo_id ? val.promo_id : null
        this.selectedRatesDocument = val.ratesDocument_id ? val.ratesDocument_id : null
      }
    },

    components: { Advantage, draggable, InvestmentPath, Rate, Editor }
  }
</script>

<style>
.page-header-wrapper {
  background-size: cover !important;
  background-position: center !important;
}

.page-header {
  margin: 0 auto;
}

.investment-description {
  /* max-width: 600px; */
  margin: 0 auto;
  position: relative;
  background: #eeeeee;
  display: block !important;
}

.investment {
  width: calc(100% - 200px);
  display: flex;
  flex-direction: column;
}

.caption {
  text-align: center;
  margin: 20px 0;
}

.rates {
  background: #eeeeee;
  padding: 30px;
}

.description-wrapper {
  padding: 30px 20px;
}

.gray-wrapper {
  /* background: #eeeeee; */
  padding: 20px 20px;
}

.advantages .button-wrapper {
  justify-content: center;
}

.pathes {
  padding: 10px;
}

.p-option {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
}

.rates-file {
  position: relative;
}
.rates-file .delete-icon {
  top: 0px;
  right: -35px;
}

.color-black {
  color: #363636 !important;
}

.promo-wrapper {
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?7f51def8